import actions from './actions';
import mutations from './mutations';

const reports = {
    namespaced: true,
    state: {
        tariffs: {
            items: [],
            pagination: {
                page: 1,
                totalPages: 1
            },
            filters: {
                optionName: null,
                optionClassId: null,
                brandId: null
            }
        },
        commissions: initState(),
        penalties: initState(),
        commissionSystems: initState()
    },
    mutations,
    actions
};

function initState() {
    return ({
        items: [],
        pagination: {
            page: 1,
            totalPages: 1
        },
        filters: {
            title: null,
            name: null,
            brandId: null,
            status: 'active'
        }
    });
}

export default reports;
